<template>
  <div>
    <div class="hiaTable truCodeEnabled VueTables VueTables--client table-responsive">
      <table class="VueTables__table table table-striped table-bordered table-hover">
        <thead>
          <tr>
            <th class="VueTables__sortable codeCol">
              <span class="VueTables__heading">Orig. Dx</span>
            </th>
            <!-- <th class="VueTables__sortable fiftyPx">
              <span class="VueTables__heading">POA</span>
            </th> -->
            <th class="VueTables__sortable twentyFivePercent">
              <span class="VueTables__heading">Desc.</span>
            </th>
            <th class="VueTables__sortable seventyFivePx">
              <span class="VueTables__heading">HCC</span>
            </th>
            <th class="VueTables__sortable codeCol">
              <span class="VueTables__heading">Rec. Dx</span>
            </th>
            <!-- <th class="VueTables__sortable fiftyPx">
              <span class="VueTables__heading">POA</span>
            </th> -->
            <th class="VueTables__sortable twentyFivePercent">
              <span class="VueTables__heading">Desc.</span>
            </th>
            <th class="VueTables__sortable seventyFivePx">
              <span class="VueTables__heading">HCC</span>
            </th>
            <th class="VueTables__sortable tenPercent reasonForChangeColreasonForChange-sorted-asc">
              <span class="VueTables__heading">Reason For Change</span>
            </th>
            <th class="VueTables__sortable">
              <span class="VueTables__heading"></span>
            </th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(value, key, index) in compGroupDXs">
            <tr :id="index" class="codeTypeHeader" :key="key">
              <td colspan="10">
                {{ key }}
              </td>
            </tr>
            <tr v-for="value2 in value" :key="value2.cptId" :class="value2.recommendedDx || value2.originalDeleted || value2.newPrimary || value2.recommendedPOA ? 'VueTables__row  highlight' : 'VueTables__row'">
              <td>
                <div>{{ value2.originalDx }}</div>
              </td>
              <!-- <td>
                <div style="text-align: center;">{{ value2.originalPOA }}</div>
              </td> -->
              <td>
                <div style="text-transform: lowercase;">
                  {{ value2.originalDescription }} <span v-if="value2.originalGrouperFlags" :title="getGrouperflagsTitle(value2.originalGrouperFlags)" class="grouperFlags">({{ value2.originalGrouperFlags }})</span>
                </div>
              </td>
              <td>
                <div>{{ value2.originalHccs }}</div>
                <div>{{ value2.originalHccsV28 }}</div>
              </td>
              <td>
                <div>{{ value2.recommendedDx }}</div>
              </td>
              <!-- <td>
                <div style="text-align: center;">{{ value2.recommendedPOA }}</div>
              </td> -->
              <td>
                <div style="text-transform: lowercase;">
                  {{ value2.recommendedDesc }} <span :title="getGrouperflagsTitle(value2.recommendedGrouperFlags)" v-if="(value2.recommendedDx && value2.recommendedGrouperFlags) || (value2.recommendedGrouperFlags && value2.recommendedGrouperFlags !== value2.originalGrouperFlags)" class="grouperFlags">({{ value2.recommendedGrouperFlags }})</span>
                </div>
              </td>
              <td>
                <div>{{ value2.recommendedHccs }}</div>
                <div>{{ value2.recommendedHccsV28 }}</div>
              </td>
              <td>
                {{ value2.reasonForChange }}
              </td>
              <td>
                <el-button style="margin-right: 5px;" size="mini" v-if="(value2.recommendedDx || value2.originalDeleted || value2.recommendedPOA) && !(worksheet.hideExcludedCodesResponseFromNucleus && value2.codeNumber === 9)" type="text" @click="addResponse(value2)" :disabled="readOnly">Respond </el-button>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
      <div style="color: #909399; margin: 0px 0px 0px 5px;" v-if="!compGroupDXs.length">Not matching records</div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import dateHelper from '@/mixins/date-helper'
import HiaAuthorization from '@/mixins/hiaAuthorization'
import { format, parseISO } from 'date-fns'

export default {
  name: 'coderOutpatientDxs',
  mixins: [dateHelper, HiaAuthorization],
  props: ['worksheet', 'readOnly'],
  data() {
    return {
      format: format,
      parseISO: parseISO,
      disabled: true,
      loading: false,
      columns: ['originalDx', 'originalDescription', 'recommendedDx', 'recommendedDesc', 'reasonForChange', 'response'],
      options: {
        filterable: false,
        filterByColumn: false,
        resizableColumns: false,
        queue: [],
        networkFunction: null,
        perPage: 100,
        rowClassCallback: row => {
          if (row.recommendedDx || row.originalDeleted || row.newPrimary || row.recommendedPOA) {
            return 'highlight'
          }
          return ''
        },
        columnsClasses: {
          originalDx: 'codeCol',
          originalPoa: 'fiftyPx',
          originalDescription: 'twentyFivePercent',
          recommendedDx: 'codeCol',
          recommendedPoa: 'fiftyPx',
          recommendedDesc: 'twentyFivePercent',
          reasonForChange: 'reasonForChangeCol'
        },
        headings: {
          originalDx: 'Orig. Dx',
          originalPoa: 'POA',
          recommendedDx: 'Rec. Dx',
          recommendedPoa: 'POA',
          originalDescription: 'Desc.',
          recommendedDesc: 'Desc.',
          reasonForChange: 'Reason For Change',
          response: ''
        }
      }
    }
  },
  methods: {
    ...mapMutations('myProjects/', ['SET_RESPONSE_ROW']),
    getGrouperflagsTitle(flagList) {
      if (!flagList) {
        return
      }

      const flagMap = {
        AD: 'Affects DRG',
        CC: 'Complication/Comorbidity',
        HC: 'Hospital-Acquired Condition',
        MC: 'Complication/Comorbidity',
        R: 'Affects Risk of Mortality',
        S: 'Affects Severity of Illness',
        AP: 'Affects Patient Safety Indicators',
        EP: 'Excludes Patient Safety Indicators',
        AQ: 'Affects Quality Measures',
        EQ: 'Excludes Quality Measures'
      }

      const flags = flagList.split(',')
      const title = []
      flags.forEach(x => {
        title.push(`${x}: ${flagMap[x]}`)
      })

      return title.join('\n')
    },
    addResponse(row) {
      this.SET_RESPONSE_ROW(row)
    }
  },
  computed: {
    compGroupDXs() {
      return this.worksheet.dxs ? Object.groupBy(this.worksheet.dxs, ({ codeDesc }) => codeDesc) : []
    }
  }
}
</script>

<style scoped>
.grouperFlags {
  font-style: italic;
  text-transform: uppercase;
}

>>> .seventyFivePx {
  width: 75px;
}

>>> .twentyFivePercent {
  min-width: 25%;
}

>>> .reasonForChangeCol {
  min-width: 120px;
}

>>> .highlight {
  /* background-color: rgba(255, 196, 12, 0.1) !important; */
  font-weight: bold;
}

>>> .highlight {
  border-left: 3px solid #f56c6c;
}

/* >>>.highlight:hover {
    background-color: rgba(255, 196, 12, 0.2) !important;
  } */

/* >>>.codeCol {
    min-width: 80px;
  } */

>>> td {
  font-size: 13px !important;
}

>>> .codeTypeHeader {
  text-align: center;
  background: rgb(28, 60, 95) !important;
  color: #ffffff;
  font-weight: bold;
}
</style>
